import { SectionProps } from './types'
import SecureInput from '../../../ui/SecureInput/SecureInput'
import { Key } from 'lucide-react'

export default function ApiKeyAuthSection({ form, styles }: SectionProps) {
  const { watch, setValue } = form
  return (
    <>
      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Key Name"
          icon={<Key size={16} />}
          value={watch('apikey.key_name') || ''}
          onChange={(value) => setValue('apikey.key_name', value)}
          placeholder="e.g. X-API-Key, Authorization"
          autoComplete="off"
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="password"
          label="Key Value"
          icon={<Key size={16} />}
          value={watch('apikey.key_value') || ''}
          onChange={(value) => setValue('apikey.key_value', value)}
          skipPasswordValidation={true}
          placeholder="Your API key"
          autoComplete="new-password"
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Send In</label>
        <select
          value={watch('apikey.in') || 'header'}
          onChange={(e) => setValue('apikey.in', e.target.value as 'header' | 'query')}
          className={styles.select}
        >
          <option value="header">Header</option>
          <option value="query">Query Parameter</option>
        </select>
      </div>
    </>
  )
}
